module.exports = __webpack_public_path__ + "img/404.db18abdc.svg";